<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <add-survey *ngIf="!isFinished" [surveyId]="surveyId" [userId]="userId" (surveySubmitted)="onSubmit($event)" (surveyCalculatingFinished)="onSurveyCalculatingFinished()"></add-survey>
  <survey-results *ngIf="isFinished" [surveyId]="surveyId" [surveyResult]="surveyResult" (surveyProgramsAdded)="onAddPrograms($event)"></survey-results>
</div>
